import axios from 'axios';

axios.interceptors.request.use(config => {
  if (typeof window === 'undefined') {
    return config;
  }
  const token = window.localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `JWT ${token}`;
  }
  return config;
});

const candidateService = {
  async get(data) {
    const url = '/candidate/' + data.electionId;
    var objEnvio = {};
    if (data.idCandidateRole) {
      objEnvio.number = data.idCandidate;
      objEnvio.role = data.idCandidateRole;
    } else {
      objEnvio.number = data.idCandidate;
    }
    objEnvio.voting = data.voting;
    const response = await axios({
      method: 'post',
      url: url,
      data: objEnvio
    });
    if (response.data.status === 'ok') {
      return response.data;
    } else {
      throw new Error(response.data);
    }
  },
  async getWitgPagedSearch(data) {
    const url = `/candidate/${data.soartDirection}/${data.itemsPerPage}/${data.pageNumber}`;
    var pname = data.searchValue === undefined ? '' : data.searchValue;
    const response = await axios({
      method: 'get',
      url: url,
      params: {
        name: pname
      }
    });
    if (response.data.status === 'ok') {
      return response.data;
    } else {
      throw new Error(response.data);
    }
  },
  async getListCandidateElection(data) {
    const url = `/candidate/list/${data.idElection}/${data.idSection}/${data.voting}`;
    const response = await axios({
      method: 'get',
      url: url,
      params: {
        idElection: data.idElection,
        idSection: data.idSection,
        voting: data.voting
      }
    });
    if (response.data.status === 'ok') {
      return response.data;
    } else {
      throw new Error(response.data);
    }
  }
};
export default candidateService;
